<template>
  <div class="cusomer-clues">
    <Title :clickFun="openBox" />
    <div class="content">
      <div class="left-box" ref="leftbox">
        <div class="left-change" ref="change" v-if="leftshow">
          <div class="title-tips">
            <span class="title-text1">线索分布TOP</span>
            <span class="title-text2">（点击可筛选）</span>
            <div class="time-box">
              <el-select
                v-model="time"
                class="select-time"
                style="width: 220px"
                size="mini"
                placeholder="请选择"
                @change="selecttime"
              >
                <el-option
                  v-for="item in timelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <i class="el-icon-time icon-time"></i>
            </div>
            <el-date-picker
              v-if="customshow"
              class="clues-picker"
              style="width: 200px"
              v-model="date"
              @change="changepage"
              value-format="yyyy-MM-dd"
              type="daterange"
              align="right"
              unlink-panels
              :clearable="false"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="title-tips">
            <span class="title-text1">线索分布TOP</span>
            <span class="title-text2">（点击可筛选）</span>
          </div>
          <div class="mt10 bar-box">
            <Bar ref="bar" @changemeida="changemeida"></Bar>
          </div>
          <div class="title-tips">
            <span class="title-text1">线索分布TOP</span>
            <span class="title-text2">（点击可筛选）</span>
          </div>
          <div class="car-box mt10">
            <div
              class="car-li"
              v-for="(item, index) in proList"
              :key="index"
              :class="carindex == index ? 'bgc' : ''"
              @click="changecar(index, item.model_name)"
            >
              <div class="rank-box">
                <span class="rank-num">{{ index + 1 }}</span>
              </div>
              <div class="car-name">{{ item.model_name }}</div>
              <img
                class="car-img"
                :src="`http://www.che007.com/${item.img}` | filterImg()"
                alt=""
              />
              <img
                v-if="carindex == index"
                class="select-img"
                src="@/assets/img/new/true-bar.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="middle-box">
          <img
            class="fold-box"
            @click="btnflod"
            ref="fold"
            src="@/assets/img/new/fold-img.png"
            alt=""
          />
        </div>
      </div>

      <div class="right-table" ref="rightTable" v-if="rightshow">
        <div class="title-tips" style="border: 0">
          <span class="title-text1">线索明细</span>
        </div>
        <el-table border :data="tableData" style="width: 100%">
          <el-table-column label="线索编号" width="80" fixed>
            <template slot-scope="scope">
              <div class="center">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="处理状态" width="100">
            <template slot-scope="scope">
              <div class="handle-box">
                {{ scope.row.status | getname }}
                <i class="down-pic"></i>
                <el-select
                  class="down-handle"
                  v-model="scope.row.status"
                  placeholder="请选择"
                  @change="changeClue(scope.row)"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="线索位置" width="80">
            <template slot-scope="scope">
              <div class="center">
                {{ scope.row.clue.lead_type_str }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="平台" width="80">
            <template slot-scope="scope">
              <div class="center">
                <img
                  style="vertical-align: middle; width: 100%"
                  :src="scope.row.clue.media_img"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系用户">
            <template slot-scope="scope">
              <div class="user-box">
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>{{ scope.row.clue.customer }}</div>
                  </div>
                  <div
                    class="user center"
                    @click="opensure(scope.row.clue.personal_link)"
                  >
                    {{ scope.row.clue.customer }}
                  </div>
                </el-tooltip>
                <img
                  class="qrcode-pic"
                  @click="qrCode(scope.row.clue.personal_link, scope.row.clue)"
                  src="@/assets/img/new/code.png"
                  alt=""
                />
                <!-- <i
                  class="el-icon-picture qrcode-pic"
                 
                ></i> -->
                <!-- <div
                  class="qrcode"
                  v-show="scope.row.id == activeid"
                  :id="`qrCode${scope.row.id}`"
                ></div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" width="80">
            <template slot-scope="scope">
              <div class="center">
                {{ scope.row.clue.time_diff }}
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="300" label="线索摘要" fixed="right">
            <template slot-scope="scope">
              <el-tooltip placement="top" effect="light">
                <div slot="content">
                  <div v-html="scope.row.clue.content"></div>
                </div>
                <div
                  class="actri"
                  v-html="scope.row.clue.summary"
                  @click="getDeatil(scope.row.clue.article_id)"
                ></div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="clear mt10">
          <div class="right mt10">
            <span style="color: #727171">当前显示{{ tableData.length }}条</span>
            <el-pagination
              style="display: inline-block; vertical-align: middle"
              background
              @current-change="getData"
              :current-page.sync="page"
              :page-size="pagesize"
              layout="prev,pager,next,total"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>是否联系用户</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contact(2)">直接联系7天内不提示</el-button>
        <el-button type="primary" @click="contact(1)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="`联系用户：${this.username}`"
      :visible.sync="codeshow"
      width="350px"
      :before-close="handleClose2"
      center
    >
      <div style="margin: auto" id="qrcode"></div>
      <div class="bottom-text">
        请用<span class="from-media">{{ from_media }}APP</span>扫描二维码
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="codeshow = false">关 闭</el-button>
      </span> -->
    </el-dialog>
    <DetailData ref="alone"></DetailData>
  </div>
</template>
<script>
import Bar from "./Customer/bar";
import DetailData from "@/components/DetailData/aloneDetail";
import QRCode from "qrcodejs2";
export default {
  components: {
    Bar,
    DetailData,
  },
  data() {
    return {
      visible: false,
      dialogVisible: false,
      time: "",
      date: "",
      timelist: [],
      start_time: "",
      end_time: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              let h = start.getHours(); //获取系统时，
              let m = start.getMinutes(); //分
              let s = start.getSeconds(); //秒

              start.setTime(
                start.getTime() - (h * 3600 * 1000 + m * 60 * 1000 + s * 1000)
              );

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              let h = start.getHours(); //获取系统时，
              let m = start.getMinutes(); //分
              let s = start.getSeconds(); //秒
              start.setTime(
                start.getTime() -
                  3600 * 1000 * 24 -
                  (h * 3600 * 1000 + m * 60 * 1000 + s * 1000)
              );

              end.setTime(
                end.getTime() -
                  (h * 3600 * 1000 + m * 60 * 1000 + (s + 1) * 1000)
              );

              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [],
      tableData2: [],
      pagesize: 20,
      page: 1,
      total: 0,
      leftshow: true,
      rightshow: true,
      barList: [],
      customshow: false,
      carindex: null,
      options: [
        {
          value: 1,
          label: "新线索",
        },
        {
          value: 2,
          label: "跟进中",
        },
        {
          value: 3,
          label: "无效线索",
        },
      ],
      proList: [],
      medianame: "",
      proname: "",
      personal_link: "",
      activeid: null,
      codeshow: false,
      username: "",
      from_media: "",
    };
  },
  methods: {
    // 打开提示
    openBox() {
      this.visible = true;
    },
    changepage() {
      this.start_time = this.date[0];
      this.end_time = this.date[1];
      this.init();
    },
    async getbar() {
      let params = {
        end_time: this.end_time,
        start_time: this.start_time,
      };
      let res = await this.$api.clues.Mediatop(params);

      if (res.data.data.length > 0) {
        this.barList = [...res.data.data];
        this.$refs.bar.open(this.barList);
      }
    },
    async getPro() {
      let params = {
        end_time: this.end_time,
        start_time: this.start_time,
      };
      let res = await this.$api.clues.Protop(params);
      if (res.data.data.length > 0) {
        this.proList = [...res.data.data];
      }
    },
    getData(e) {
      this.page = e;
      this.CluesList();
    },
    btnflod() {
      this.tableData2 = [...this.tableData];
      if (this.leftshow) {
        this.tableData = [];
        this.leftshow = false;
        this.rightshow = false;
        this.$refs.rightTable.classList.add("widht");
        this.$refs.leftbox.classList.add("width");
        this.$refs.fold.classList.add("rote");
        // this.$refs.rightTable.style()
        this.tableData = this.tableData2;
        this.rightshow = true;
      } else {
        this.leftshow = true;
        this.$nextTick(() => {
          this.$refs.bar.open(this.barList);
        });
        this.$refs.rightTable.classList.remove("widht");
        this.$refs.leftbox.classList.remove("width");
        this.$refs.fold.classList.remove("rote");
        this.rightshow = false;
        this.rightshow = true;
      }
    },
    opensure(row) {
      console.log(row);
      let time = window.localStorage.getItem("tipstime") || 0;
      let timenow = Date.now();
      this.personal_link = row;
      if (timenow - time > 60000 * 60 * 24 * 7) {
        this.dialogVisible = true;
      } else {
        window.open(row, "_blank");
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    contact(type) {
      if (type == 2) {
        let date = Date.now();
        window.localStorage.setItem("tipstime", date);
      }
      this.dialogVisible = false;
      window.open(this.personal_link, "_blank");
    },
    fun_date(num) {
      var date1 = new Date();
      //今天时间
      var time1 =
        date1.getFullYear() +
        "-" +
        (date1.getMonth() + 1) +
        "-" +
        date1.getDate();

      var date2 = new Date(date1);
      date2.setDate(date1.getDate() - num);
      //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
      var time2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
      return time2;
    },
    selecttime() {
      if (this.time == "自定义") {
        this.customshow = true;
      } else {
        console.log(this.time);
        let time = this.time.split(",");
        this.start_time = time[0];
        this.end_time = time[1];
        this.getbar();
        this.customshow = false;
        this.date = [this.start_time, this.end_time];
        this.init();
      }
    },
    async CluesList() {
      let params = {
        end_time: this.end_time,
        start_time: this.start_time,
        pro: this.proname,
        media: this.medianame,
        page: this.page,
        pagesize: this.pagesize,
      };
      let res = await this.$api.clues.CluesList(params);

      if (res.status == 200) {
        this.total = res.data.total;
        this.tableData = [...res.data.page_data];
      }
    },
    async changeClue(param) {
      let res = await this.$api.clues.Cluechange(param.id, {
        status: param.status,
      });
      if (res.status == 200) {
        this.$message({
          type: "success",
          message: "处理成功!",
        });
      } else {
        this.$message.error(res.data.msg);
      }
    },
    init() {
      let p0 = new Promise((resolve, reject) => {
        resolve(this.getbar());
      });
      let p1 = new Promise((resolve, reject) => {
        resolve(this.getPro());
      });

      Promise.all([p0, p1])
        .then((result) => {
          this.CluesList();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changemeida(val) {
      this.page = 1;
      this.medianame = val;
      this.CluesList();
    },
    changecar(index, name) {
      this.page = 1;
      if (this.carindex == index) {
        this.carindex = null;
        this.proname = "";
      } else {
        this.carindex = index;
        this.proname = name;
      }

      this.CluesList();
    },
    getDeatil(id) {
      let obj = {
        article_id: id,
      };
      this.$refs.alone.open(obj);
    },
    qrCode(url, username) {
      this.codeshow = true;
      this.username = username.customer;
      this.from_media = username.from_media;
      let qrcode = null;

      this.$nextTick(() => {
        document.getElementById("qrcode").innerHTML = "";
        qrcode = new QRCode("qrcode", {
          width: 150, //图像宽度
          height: 150, //图像高度
          colorDark: "#000000", //前景色
          colorLight: "#ffffff", //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        });
        qrcode.clear();
        qrcode.makeCode(url); //生成另一个新的二维码
      });
    },
    handleClose2() {
      this.codeshow = false;
    },
  },
  filters: {
    getname(name) {
      let name2 = "";
      switch (name) {
        case 1: {
          name2 = "新线索";
          break;
        }
        case 2: {
          name2 = "跟进中";
          break;
        }
        default: {
          name2 = "无效线索";
        }
      }
      return name2;
    },
  },
  mounted() {
    let date = new Date();
    let nowtime = this.moment(date.toLocaleDateString()).format("YYYY-MM-DD");
    let day7 = this.moment(this.fun_date(6)).format("YYYY-MM-DD");
    let day30 = this.moment(this.fun_date(29)).format("YYYY-MM-DD");
    let day90 = this.moment(this.fun_date(89)).format("YYYY-MM-DD");
    this.end_time = nowtime;
    this.start_time = day7;
    this.time = `近7天${day7}~${nowtime}`;
    this.date = [day7, nowtime];
    this.timelist = [
      {
        value: `${day7},${nowtime}`,
        label: `近7天${day7}~${nowtime}`,
      },
      {
        value: `${day30},${nowtime}`,
        label: `近30天${day30}~${nowtime}`,
      },
      {
        value: `${day90},${nowtime}`,
        label: `近90天${day90}~${nowtime}`,
      },
      {
        value: "自定义",
        label: `自定义`,
      },
    ];
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.cusomer-clues {
  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
  }
  .center {
    text-align: center;
  }
  .title-tips {
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #e4e4e4;
    box-sizing: border-box;
    .title-text1 {
      font-size: 16px;
      font-weight: bold;
      color: #141a88;
    }
    .title-text2 {
      font-size: 14px;
      color: #a6a6a7;
    }
    .time-box {
      display: inline-block;
      position: relative;
      margin-left: 30px;
      .icon-time {
        position: absolute;
        top: 23px;
        left: 5px;
        color: #c7c8ca;
      }
    }
  }
  .left-box {
    position: relative;
    width: 755px;
    background-color: #dfdfdf;
    border-radius: 5px;
    margin-right: 20px;
    &.width {
      width: 20px;
    }
    .left-change {
      position: relative;
      width: 732px;
      background-color: #fff;
      border-radius: 5px;
      &.width {
        width: 0;
      }
      .bar-box {
        box-sizing: border-box;
        padding: 0 20px 0 10px;
        border-bottom: 1px solid #e4e4e4;
      }
      .car-box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        .car-li {
          position: relative;
          width: 170px;
          height: 169px;
          border: 1px solid #e4e4e4;
          margin-bottom: 20px;
          margin-left: 8px;
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;
          &.bgc {
            background-color: #f2f5ff;
          }
          .rank-box {
            position: absolute;
            left: 2px;
            top: 2px;
            width: 0;
            height: 0;
            border-width: 15px;
            border-style: solid;
            border-color: #c5c5c5 transparent transparent #c5c5c5;
            .rank-num {
              position: absolute;
              top: -14px;
              left: -11px;
              color: #fff;
            }
          }
          .car-img {
            // width: 146px;
            // height:100px ;
            height: 105px;
            margin-top: 30px;
          }
          .car-name {
            text-align: center;
            color: #727171;
            font-weight: bold;
            margin-top: 14px;
          }
          .select-img {
            position: absolute;
            right: 4px;
            top: 4px;
          }
        }
      }
    }
    .middle-box {
      position: absolute;
      width: 20px;
      right: 0;
      top: 0;
      height: 100%;
      .fold-box {
        position: absolute;
        width: 15px;
        height: 21px;
        top: 50%;
        margin-top: -11.5px;
        left: 1.25px;
        cursor: pointer;
        &.rote {
          transform: rotate(180deg);
          left: 3.2px;
        }
      }
    }
  }

  .right-table {
    width: calc(100% - 775px);
    background-color: #fff;
    margin-left: 20px;
    /deep/.el-table th > .cell {
      text-align: center;
      height: 28px;
      color: #141a88;
      line-height: 28px;
      font-weight: normal;
    }
    /deep/.el-table td {
      height: 36px;
      line-height: 36px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .down-pic {
      float: right;
      border-width: 5px;
      border-style: solid;
      margin-top: 10px;
      border-color: #fe2248 transparent transparent transparent;
    }

    &.widht {
      width: calc(100% - 20px);
    }
    .actri {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
    .user-box {
      .user {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        line-height: 35px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        padding-right: 35px;
        padding-left: 5px;
        box-sizing: border-box;
      }
      .qrcode-pic {
        position: absolute;
        height: 35px;
        right: 0px;
        top: 0px;
        cursor: pointer;
      }
      .qrcode {
        position: absolute;
        top: -75px;
        width: 150px;
        height: 150px;
        left: 50%;
        margin-left: -75px;
        z-index: 10;
        overflow: hidden;
      }
    }

    .handle-box {
      position: relative;
      .down-handle {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 26px;
        opacity: 0;
        /deep/input {
          opacity: 0;
          height: 0;
        }
      }
    }
  }
  .mt10 {
    margin-top: 10px;
  }
  .ml20 {
    vertical-align: middle;
    margin-left: 20px;
  }
  .bottom-text {
    text-align: center;
    margin-top: 20px;
    .from-media {
      color: #141a88;
    }
  }
}
</style>
<style >
.cusomer-clues img {
  margin: auto;
}
.clues-picker {
  vertical-align: middle;
  margin-left: 10px;
}
.cusomer-clues .el-table__fixed,
.el-table__fixed-right {
  height: 100% !important;
}
.cusomer-clues .select-time .el-input__inner {
  color: #141a88 !important;
  background-color: #f2f5ff;
  padding-left: 20px;
}
.cusomer-clues .el-table td,
.el-table th.is-leaf {
  position: relative;
  border-right: 1px solid #ebeef5;
}
.cusomer-clues .el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
}
.cusomer-clues .el-table__empty-block {
  border-bottom: 1px solid #ebeef5;
}
</style>